module.exports = __webpack_public_path__ + "img/2.1.231d2872.png";